import { ClientPostTypeEnum } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useTranslation } from 'react-i18next';

import { useGetPostTypeFeature } from '@/features/post-editor/hooks/useGetPostFeature';
import { usePostCard } from '@/features/posts/components/feed/PostCardContext';
import { TODAY } from '@/features/posts/constants/params';
import { useGetPostCategoryLabel } from '@/features/posts/hooks/useGetPostCategoryLabel';
import { PostFeedType } from '@/features/posts/types/postFeed';
import { getHappeningCardDateString } from '@/features/posts/utils/post';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

type UsePostCardHeaderConfig = {
  postType?: ClientPostTypeEnum | PostFeedType;
  startTime?: number;
  endTime?: number;
  allDayEvent?: boolean;
  category?: string;
  channelName?: string;
};

export const usePostCardHeaderContent = ({
  postType,
  category
}: UsePostCardHeaderConfig) => {
  const { startTime, endTime, allDayEvent } = usePostCard();

  const postTypeFeature = useGetPostTypeFeature(
    postType as ClientPostTypeEnum | PostFeedType
  );
  const { t } = useTranslation(LocalizationNameSpace.POSTS, {
    keyPrefix: 'types'
  });
  const getCategoryLabel = useGetPostCategoryLabel();
  // Localize known category values (e.g. "official"); pass through unknown
  // free-form ones (e.g. crawler categories) unchanged.
  const categoryLabel = getCategoryLabel(category);

  switch (postType) {
    case PostFeedType.EMERGENCY: {
      return t(PostFeedType.EMERGENCY);
    }
    case ClientPostTypeEnum.Seeking:
    case ClientPostTypeEnum.Offer:
    case ClientPostTypeEnum.SpecialPost:
    case ClientPostTypeEnum.NewsItem:
    case PostFeedType.CIVIL_PROTECTION: {
      return categoryLabel ?? postTypeFeature.channelName;
    }

    case ClientPostTypeEnum.Happening: {
      if (startTime && endTime) {
        // oxlint-disable-next-line react/purity
        if (endTime < Date.now() || (allDayEvent && endTime < TODAY)) {
          return 'Bereits stattgefunden';
        } else {
          return getHappeningCardDateString({
            startTime,
            endTime
          });
        }
      } else {
        return '';
      }
    }
    default: {
      return;
    }
  }
};
